import { apiDev } from '@/scripts/axios';
import { catchError } from '@/scripts/utils/store-dependent';

const unsubscribe = params =>
  apiDev
    .post(`users/unsubscribe`, params)
    .then(({ data: { response } }) => response)
    .catch(catchError);

export { unsubscribe };
